import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addReactionFailure,
  addReactionSuccess,
  deleteTagFailure,
  deleteTagSuccess,
  fetchReactionsFailure,
  fetchReactionsSuccess,
  searchTagFailure,
  searchTagSuccess,
  acknowledgeFeedFailure,
  acknowledgeFeedSuccess,
  fetchStatsSuccess,
  fetchStatsFailure,
  fetchEngageReportSuccess,
  fetchEngageReportFailure,
} from "./actions";
import {
  ADD_REACTION,
  DELETE_TAG,
  FETCH_REACTIONS,
  SEARCH_TAG,
  ACKNOWLEDGE_FEED,
  FETCH_STATS,
  FETCH_ENGAGE_REPORT,
} from "./constants";

export function* searchTagsSaga({ payload, onSuccess, values }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/search-feed-tag?${query}`
    );
    yield put(searchTagSuccess(data));
    typeof onSuccess === "function" && onSuccess(data, values);
  } catch (e) {
    yield put(searchTagFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}

export function* deleteTagSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/feed-tag/${payload}`);
    if (data) {
      yield put(successAlert("Tag removed successfully!"));
      yield put(deleteTagSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteTagFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addReactionSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/reaction-create-delete`,
      payload
    );
    if (data) {
      yield put(addReactionSuccess(data));
      typeof onSuccess === "function" && onSuccess(data);
    }
  } catch (e) {
    yield put(addReactionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchReactionsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/feed-reaction-type-list/${payload}`
    );
    yield put(fetchReactionsSuccess(data));
  } catch (e) {
    yield put(fetchReactionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* acknowledgeFeedSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/feed-acknowledgement/add`,
      payload
    );
    if (data) {
      yield put(acknowledgeFeedSuccess(data));
      typeof onSuccess === "function" && onSuccess(data);
    }
  } catch (e) {
    yield put(acknowledgeFeedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/feed-acknowledgement-stats/${payload}`
    );
    yield put(fetchStatsSuccess(data));
  } catch (e) {
    yield put(fetchStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEngageReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";

  try {
    const { data } = yield call(
      api(token).get,
      `/api/engagement-report?${query}`
    );
    yield put(fetchEngageReportSuccess(data));
  } catch (e) {
    yield put(fetchEngageReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchTagsFlow() {
  yield takeEvery(SEARCH_TAG, searchTagsSaga);
}

export function* deleteTagFlow() {
  yield takeEvery(DELETE_TAG, deleteTagSaga);
}

export function* addReactionFlow() {
  yield takeEvery(ADD_REACTION, addReactionSaga);
}

export function* fetchReactionsFlow() {
  yield takeEvery(FETCH_REACTIONS, fetchReactionsSaga);
}

export function* acknowledgeFeedFlow() {
  yield takeEvery(ACKNOWLEDGE_FEED, acknowledgeFeedSaga);
}

export function* fetchStatsFlow() {
  yield takeEvery(FETCH_STATS, fetchStatsSaga);
}

export function* fetchEngageReportFlow() {
  yield takeEvery(FETCH_ENGAGE_REPORT, fetchEngageReportSaga);
}

export default function* FeedActionSaga() {
  yield all([
    searchTagsFlow(),
    deleteTagFlow(),
    addReactionFlow(),
    fetchReactionsFlow(),
    acknowledgeFeedFlow(),
    fetchStatsFlow(),
    fetchEngageReportFlow(),
  ]);
}
